import React from 'react';
import { Box } from '@mui/material';
import {
  School as SchoolIcon,
  Palette as PaletteIcon,
  Work as WorkIcon
} from '@mui/icons-material';
import { IHighlight } from './types';

export default function HighlightIcon({ highlight }: { highlight: IHighlight }) {
  if (highlight.kind === 'experience') {
    return (
      <Box sx={{ color: '#9c27b0', mb: 1 }}>
        <WorkIcon />
      </Box>
    );
  }

  if (highlight.kind === 'education') {
    return (
      <Box sx={{ color: '#00bcd4', mb: 1 }}>
        <SchoolIcon />
      </Box>
    );
  }

  if (highlight.kind === 'skills') {
    return (
      <Box sx={{ color: '#e91e63', mb: 1 }}>
        <PaletteIcon />
      </Box>
    );
  }

  return null;
}
